exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".img-crop-container[data-v-b011c2d8]{max-width:600px;max-height:600px}.img-crop-container[data-v-b011c2d8] img{max-width:600px;max-height:600px}\n", ""]);

